import apiProxy from "@shared/utils/api-proxy";
import { useAuthorizationStore } from "@shared/stores/authorization";
import { type UserAuthorizationResponse } from "@shared/types/common";
import { USER_AUTHORIZATION_SUBSCRIPTIONS } from "@shared/services/tour/urls/dashboard-urls";

export const authorizationService = {
  fetchAuthorization: async (): Promise<UserAuthorizationResponse> => {
    const response = await apiProxy.get<UserAuthorizationResponse>(
      USER_AUTHORIZATION_SUBSCRIPTIONS,
    );

    if (!response) {
      throw new Error("Could not load user authorization");
    }

    return response;
  },
  getAuthorization: async (): Promise<void> => {
    const authorizationStore = useAuthorizationStore();
    const response = await authorizationService.fetchAuthorization();
    authorizationStore.setAuthorization(response.authorization);
  },
};
